import React from "react"

import { Wrapper } from "./customEventWrapperStyles"

export const CustomEventWrapper = ({ children }) => (
  <Wrapper>{children}</Wrapper>
)
